import { IndicatorEsfStatusEnum } from "./enums/IndicatorEsfStatusEnum";

export enum IndicatorEsfEnum {
	C1 = 1,
	C2 = 2,
	C3 = 3,
	C4 = 4,
	C5 = 5,
	C6 = 6,
	C7 = 7,
}

type IndicatorClassification = {
	awesome: number;
	good: number;
	enough: number;
	regular: number;
	limit: number;
};

const indicatorsClassification: Record<IndicatorEsfEnum, IndicatorClassification> = {
	[IndicatorEsfEnum.C1]: { limit: 70, awesome: 50, good: 30, enough: 10, regular: 0 },
	[IndicatorEsfEnum.C2]: { limit: 100, awesome: 75, good: 50, enough: 25, regular: 0 },
	[IndicatorEsfEnum.C3]: { limit: 100, awesome: 75, good: 50, enough: 25, regular: 0 },
	[IndicatorEsfEnum.C4]: { limit: 100, awesome: 75, good: 50, enough: 25, regular: 0 },
	[IndicatorEsfEnum.C5]: { limit: 100, awesome: 75, good: 50, enough: 25, regular: 0 },
	[IndicatorEsfEnum.C6]: { limit: 100, awesome: 75, good: 50, enough: 25, regular: 0 },
	[IndicatorEsfEnum.C7]: { limit: 100, awesome: 75, good: 50, enough: 25, regular: 0 },
};

export function getIndicatorClassificationScores(indicator: IndicatorEsfEnum) {
	return indicatorsClassification[indicator];
}

export function getIndicatorClassification(indicator: IndicatorEsfEnum, percentage: number) {
	if (percentage > indicatorsClassification[indicator].limit) return "Regular";
	if (percentage >= indicatorsClassification[indicator].awesome) return "Ótimo";
	if (percentage >= indicatorsClassification[indicator].good) return "Bom";
	if (percentage >= indicatorsClassification[indicator].enough) return "Suficiente";
	return "Regular";
}

export function getIndicatorClassificationColorClassName(
	indicator: IndicatorEsfEnum,
	percentage: number
) {
	if (percentage > indicatorsClassification[indicator].limit) return "danger";
	if (percentage >= indicatorsClassification[indicator].awesome) return "primary";
	if (percentage >= indicatorsClassification[indicator].good) return "success";
	if (percentage >= indicatorsClassification[indicator].enough) return "warning";
	return "danger";
}

export function getIndicatorClassificationColorClassNameByStatus(
	status: "finished" | "pending" | "lost"
) {
	if (status === "finished") return "success";
	if (status === "pending") return "warning";
	return "danger";
}

export function getCitizenScoreStatusDescriptionIndicatorC2(
	citizenScoreStatus: "finished" | "pending" | "lost"
) {
	switch (citizenScoreStatus) {
		case "finished":
			return "Realizado";
		case "pending":
			return "Pendente";
		case "lost":
			return "Fora do prazo";
		default:
			return "";
	}
}

export function getCitizenScoreStatusDescriptionIndicatorC3(
	citizenScoreStatus: "finished" | "pending" | "lost"
) {
	switch (citizenScoreStatus) {
		case "finished":
			return "Realizado";
		case "pending":
			return "Pendente";
		case "lost":
			return "Fora do prazo";
		default:
			return "";
	}
}

export function getCitizenScoreStatusDescriptionIndicatorC4(
	citizenScoreStatus: IndicatorEsfStatusEnum
) {
	switch (citizenScoreStatus) {
		case IndicatorEsfStatusEnum.Finished:
			return "Realizado";
		case IndicatorEsfStatusEnum.Pending:
			return "Pendente";
		case IndicatorEsfStatusEnum.Lost:
			return "Fora do prazo";
		default:
			return "";
	}
}

export function getIndicatorClassificationColorClassNameByStatusC4(status: IndicatorEsfStatusEnum) {
	if (status === IndicatorEsfStatusEnum.Finished) return "success";
	if (status === IndicatorEsfStatusEnum.Pending) return "warning";
	return "danger";
}

export function getCitizenScoreStatusDescriptionIndicatorC5(
	citizenScoreStatus: IndicatorEsfStatusEnum
) {
	switch (citizenScoreStatus) {
		case IndicatorEsfStatusEnum.Finished:
			return "Realizado";
		case IndicatorEsfStatusEnum.Pending:
			return "Pendente";
		case IndicatorEsfStatusEnum.Lost:
			return "Fora do prazo";
		default:
			return "";
	}
}

export function getIndicatorClassificationColorClassNameByStatusC5(status: IndicatorEsfStatusEnum) {
	if (status === IndicatorEsfStatusEnum.Finished) return "success";
	if (status === IndicatorEsfStatusEnum.Pending) return "warning";
	return "danger";
}

export function getCitizenScoreStatusDescriptionIndicatorC6(
	citizenScoreStatus: IndicatorEsfStatusEnum
) {
	switch (citizenScoreStatus) {
		case IndicatorEsfStatusEnum.Finished:
			return "Realizado";
		case IndicatorEsfStatusEnum.Pending:
			return "Pendente";
		case IndicatorEsfStatusEnum.Lost:
			return "Fora do prazo";
		default:
			return "";
	}
}

export function getIndicatorClassificationColorClassNameByStatusC6(status: IndicatorEsfStatusEnum) {
	if (status === IndicatorEsfStatusEnum.Finished) return "success";
	if (status === IndicatorEsfStatusEnum.Pending) return "warning";
	return "danger";
}

export function getCitizenScoreStatusDescriptionIndicatorC7(
	citizenScoreStatus: IndicatorEsfStatusEnum
) {
	switch (citizenScoreStatus) {
		case IndicatorEsfStatusEnum.Finished:
			return "Realizado";
		case IndicatorEsfStatusEnum.Pending:
			return "Pendente";
		case IndicatorEsfStatusEnum.Lost:
			return "Fora do prazo";
		default:
			return "";
	}
}

export function getIndicatorClassificationColorClassNameByStatusC7(status: IndicatorEsfStatusEnum) {
	if (status === IndicatorEsfStatusEnum.Finished) return "success";
	if (status === IndicatorEsfStatusEnum.Pending) return "warning";
	return "danger";
}
